import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'developer-terminal',
    name: 'Developer Terminal',
    description: 'A retro hacker CRT printout of telemetry diagnostics and system stats.',
    category: 'entrance',
    themePreference: 'dark',
  },
  eligibility: {
    check: () => true, // Available at all times
    cooldownMs: 6 * 60 * 60 * 1000,
    basePriority: 60,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
